import React from 'react';
import './App.css';
import Glasses from './component/Glasses/Glasses';
import Header from './component/Header/Header';

function App() {
  return (
    <>
      <Header></Header>
      <Glasses></Glasses>
    </>
  );
}

export default App;
